import { useMemo } from "react";
import {
  useConnectionRegistry,
  useServiceFetch,
} from "../../../services/ConnectionRegistryProvider";
import { createEngageClient, type EngageClient } from "../../../chat/services/workflowApi";

export function useEngageClient(): EngageClient {
  const serviceFetch = useServiceFetch();
  const registry = useConnectionRegistry();
  const apiBaseUrl = registry.getConnection("engage")?.apiBaseUrl ?? "";
  return useMemo(
    () => createEngageClient(serviceFetch, apiBaseUrl),
    [serviceFetch, apiBaseUrl],
  );
}
